(function () {
  class ReelSpinnerVisualStacked extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreApp,
      numPostApp,
      layout,
      stackedSymbols
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreApp,
        numPostApp
      );
      this._layout = layout;
      this.initialiseSymbolOffsets();
      this._stackedSymbols = stackedSymbols;
      this._symbolSizes = [];
      this.initialiseSymbolSizes(resourceManager.configuration["symbols"]);
      this._symbolMovieName += "_" + layout;
      this._symbolMovieDescriptors += "_" + layout;
      this._blockData = [];

      this._fireballMovies = [];
      this._fireballCashOverlays = [];
      this._fireballPotOverlays = [];
      this._blueFireballWildOverlays = [];
      this._fireballsAreBlue = false;
      this._showBlueFireballWild = false;

      this._lockedCashValues = false;

      this._ready = false;

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
    }

    onGameConfigEvent() {
      this._ready = true;
    }

    // incase symbols are different size canvases like glows etc
    initialiseSymbolSizes(symbolData) {
      this._symbolSizes = new Array(Object.keys(symbolData).length).fill({
        x: 0,
        y: 0,
      });
      for (let prop in symbolData) {
        if (symbolData.hasOwnProperty(prop) && symbolData[prop].imageSize) {
          let data = symbolData[prop];
          this._symbolSizes[Number(data.ID)] = data.imageSize;
        }
      }

      if (this._symbolGfxObjects.length > 0) {
        this.scaleToImageSize();
      }
    }

    assignSlotMachine(newSlot) {
      super.assignSlotMachine(newSlot);

      let self = this;
      newSlot.subscribeToNewSymbolEvent(function (reelId, symbolId) {
        if (reelId === self._reelSpinnerData._reelId) {
          // we need to assign the new symbols to the gfxTextures because
          // we get notified of a new symbol before we have updated the textures
          //so if we are looking at things like texture width they point to the old symbol not new one
          self.redraw();
        }
      });

      newSlot.subscribeToSpinAbortedEvent(function () {
        self.redraw();
      });

      newSlot.subscribeToSymbolChangedEvent(function (reelId) {
        if (reelId === self._reelSpinnerData._reelId) {
          self.redraw();
        }
      });

      newSlot.subscribeToReelsLandedEvent(function (reelId) {
        if (reelId === self._reelSpinnerData._reelId) {
          self.redraw();
        }
      });

      this.redraw();
    }

    redraw() {
      this.updateSymbols();

      this.scaleToImageSize();
      this.updateClipRects();
    }

    isStackedSymbols(symId) {
      return this._stackedSymbols.indexOf(symId) !== -1;
    }

    getSymbolStackSize(symId) {
      for (let i = 0; i < this._stackedSymbols.length; ++i) {
        if (this._stackedSymbols[i].id == symId)
          return this._stackedSymbols[i].stackSize;
      }
      return 1;
    }

    onOrientationChange() {
      this.scaleToImageSize();
    }

    scaleToImageSize() {
      let symbolData = this._reelSpinnerData.getSymbolData();
      for (let i = 0; i < this._symbolGfxObjects.length; ++i) {
        let symId = symbolData[i].symId;
        let width = this._symbolGfxObjects[i].symbol.texture.width;
        let height = this._symbolGfxObjects[i].symbol.texture.height;
        let x = this._symbolSizes[symId].x / width;
        let y = this._symbolSizes[symId].y / height;
        this._symbolGfxObjects[i].scale.set(x, y);
      }
    }

    // for over hanging symbols etc
    initialiseSymbolOffsets() {
      if (this._layout)
        super.initialiseSymbolOffsets(resourceManager.configuration["symbols"]);
    }

    analyseStacksOnReel(reel) {
      // CRAIG TO EDIT THIS

      let res = [];
      for (let i = 0; i < reel.length; ) {
        let symId = reel[i];
        let symStackSize = this.getSymbolStackSize(symId);
        let isStackedSymbol = symStackSize > 1;
        let count = 1;

        for (let j = 1; j < symStackSize && i + j < reel.length; ++j) {
          if (isStackedSymbol && reel[i + j] == symId) {
            ++count;
          } else {
            break;
          }
        }

        let offset = i === 0 ? symStackSize - count : 0;

        res.push({
          row: i,
          count: count,
          symId: symId,
          blockSize: isStackedSymbol ? symStackSize : 1,
          offset: offset,
        });
        i += count;
      }
      return res;
    }

    // we dont render one big gigablox symbol. We actual render a clipped section of it. Despite how many symbols are
    // in view for this particular reel the reel itself will still be made up of 6 rows (standard gigablox layout is 6x6).
    // so if there is a 3x3 symbol in view at the top of the window, row 0 will show the top third of the symbol, row 1 middle third,
    // row 2 bottom third. This is done via cliprects. The reason for this is the ReelSpinner knows nothing about gigablox and doesnt
    // need to as it is just added complexity to the data class so the renderer needs to infer it from the data.
    updateClipRects() {
      let symbolData = this._reelSpinnerData.getSymbolData(); // symbols that need to be drawn
      this._blockData = this.calcBlockData();
      //   let symbolHeight = this._reelSpinnerData._minSymbolSpacing; // height of a 1x1 symbol
      for (let i = 0; i < symbolData.length; ++i) {
        let stackSize = this.getSymbolStackSize(symbolData[i].symId);
        let imageSize = this._symbolSizes[symbolData[i].symId]; // size of the sprite (the actual gigablox size)
        let symbolHeight = imageSize.y / stackSize; // height of a 1x1 symbol, cant use minSymbolSpacing due to symbols with bigger texture  heights (see 6x6 bonus symbol on hunters moon)
        let blockOffset = symbolHeight * this._blockData[i]; // height of this symbol based on the size of the gigablox

        let scale = this._symbolGfxObjects[i].scale;
        this._symbolGfxObjects[i].symbol.mask.clear();
        this._symbolGfxObjects[i].symbol.mask.beginFill(0x000000, 0);

        let width = imageSize.x / scale.x;
        let left = -(width / 2);
        let top =
          blockOffset / scale.y + this._symbolOffset[symbolData[i].symId].y;
        let height =
          imageSize.y / scale.y / stackSize +
          1 -
          this._symbolOffset[symbolData[i].symId].y; // + 1 because we need to make the clip rect 1 pixel high otherwise on none native aspect ratios you can get a pixel slice between the symbols

        top -= symbolHeight / 2;
        if (stackSize === 3) {
          top -= symbolHeight;
        } else if (stackSize === 2) {
          top -= symbolHeight;
          height += symbolHeight / 2;
        }

        this._symbolGfxObjects[i].symbol.mask.drawRect(
          left,
          top,
          width,
          height
        );
        this._symbolGfxObjects[i].symbol.mask.endFill();
      }
    }

    calcBlockData() {
      let blockInfo = [];
      let reelId = this._reelSpinnerData._reelId;

      let data = this._reelSpinnerData.getSymbolData();
      let symbs = [];
      for (let i = 0; i < data.length; ++i) {
        symbs.push(data[i].symId);
      }

      // if (this._reelSpinnerData._reelSpinning){
      blockInfo = this.analyseStacksOnReel(symbs);
      // }else{
      //    blockInfo = this.getReelBlockInfo(reelId);
      // }

      let remainingRows = this._reelSpinnerData.getMaxSymbolsInWindow();
      let res = [];

      if (!blockInfo) {
        //     if (this._reelSpinnerData._reelSpinning){
        blockInfo = this.analyseStacksOnReel(symbs);
        //   }else{
        //       blockInfo = this.getReelBlockInfo(reelId);
        //    }
      }

      for (let i = 0; i < blockInfo.length; ++i) {
        let block = blockInfo[i];
        let numToDraw = Math.min(block.count, remainingRows);

        let startOffset = block.offset;
        for (let j = 0; j < numToDraw; ++j) {
          res.push(startOffset + j);
        }

        remainingRows -= numToDraw;
      }

      let lastWindowSymOffset = res[res.length - 1];

      // handle preapp
      if (blockInfo[0].offset === 0) {
        // if next symbol is stacked
        let preappSymId = symbs[this._reelSpinnerData._preAppertureSymbolIdx];
        let ss = this.getSymbolStackSize(preappSymId);
        res.push(ss - 1);
      } else {
        res.push(blockInfo[0].offset - 1); // preapp should be symbol above this in the stack
      }

      // handle postapp
      let lastSymIdx = this._reelSpinnerData._preAppertureSymbolIdx - 1;
      let lastSymInWindow = symbs[lastSymIdx];
      let lastSymSS = this.getSymbolStackSize(lastSymInWindow);

      if (lastSymSS === 1) {
        res.push(0);
      } else {
        if (
          lastSymInWindow !==
          symbs[this._reelSpinnerData._postAppertureSymbolIdx]
        ) {
          res.push(0);
        } else {
          res.push(lastWindowSymOffset + 1);
        }
      }

      return res;
    }

    updateSymbolPositions(positions) {
      let symbolData = this._reelSpinnerData.getSymbolData(); // symbols that need to be drawn

      let symbolHeight = this._reelSpinnerData._minSymbolSpacing;
      for (let i = 0; i < positions.length; ++i) {
        let stackSize = this.getSymbolStackSize(symbolData[i].symId);
        let pos = positions[i];
        let yPos = pos.y;
        let blockOffset = symbolHeight * this._blockData[i] + 1; // + 1 because we need to make the clip rect 1 pixel high otherwise on none native aspect ratios you can get a pixel slice between the symbols

        if (stackSize === 3) {
          blockOffset -= symbolHeight;
        } else if (stackSize === 2) {
          blockOffset -= symbolHeight / 2;
        }

        if (this._reelSpinnerData._reelId === "reel1") {
          //pos.x += Math.random() * 100
        }

        yPos -= blockOffset;
        this._symbolGfxObjects[i].position.setX(pos.x);
        this._symbolGfxObjects[i].position.setY(yPos);
      }
    }

    createFireballMovies() {
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let fireball = resourceManager.createObject(
          "movie",
          "Symbol_Fireball",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Fireball",
            anchor: 0.5,
          }
        );
        fireball.visible = false;
        //fireball.gotoAndStop(0);

        let bluefireball = resourceManager.createObject(
          "movie",
          "Symbol_BlueFireball",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Wild",
            anchor: 0.5,
          }
        );
        bluefireball.visible = false;
        //bluefireball.gotoAndStop(0);

        let pinkfireball = resourceManager.createObject(
          "movie",
          "Symbol_Fireball_Pink",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Fireball_Pink",
            anchor: 0.5,
          }
        );
        pinkfireball.visible = false;
        //pinkfireball.gotoAndStop(0);

        this._fireballMovies.push({ fireball, bluefireball, pinkfireball });
      }
    }

    createFireballCashOverlays() {
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];
        let overlay = resourceManager.createObject(
          "text",
          "fireballCashOverlay",
          gfxObject.symbol.childContainer,
          {
            text: "???",
            fontDefinition: "whiteGlow",
            fontSize: 34,
            maxWidth: 140,
            anchor: 0.5,
          }
        );
        overlay.visible = false;
        this._fireballCashOverlays.push(overlay);
      }
    }

    createFireballPotOverlays() {
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let miniOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMiniOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MINI.png",
            anchor: 0.5,
          }
        );
        miniOverlay.visible = false;
        let minorOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMinorOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MINOR.png",
            anchor: 0.5,
          }
        );
        minorOverlay.visible = false;
        let majorOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMajorOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MAJOR.png",
            anchor: 0.5,
          }
        );
        majorOverlay.visible = false;
        let megaOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMegaOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MEGA.png",
            anchor: 0.5,
          }
        );
        megaOverlay.visible = false;

        this._fireballPotOverlays.push({
          mini: miniOverlay,
          minor: minorOverlay,
          major: majorOverlay,
          mega: megaOverlay,
        });
      }
    }

    createBlueFireballWildOverlays() {
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let overlay = resourceManager.createObject(
          "sprite",
          "wildOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "wildFire/Wild_Txt.png",
            anchor: 0.5,
          }
        );
        overlay.visible = false;

        this._blueFireballWildOverlays.push(overlay);
      }
    }

    turnFireballsBlue(blue) {
      this._fireballsAreBlue = blue;
    }

    showBlueFireballWild(show) {
      this._showBlueFireballWild = show;
    }

    showFireballMovie(i, show, forceBlue) {
      this._fireballMovies[i].pinkfireball.visible = false;
      if (show) {
        if (this._fireballsAreBlue || forceBlue) {
          this._fireballMovies[i].fireball.visible = !show;
          this._fireballMovies[i].bluefireball.visible = show;
        } else {
          this._fireballMovies[i].bluefireball.visible = !show;
          this._fireballMovies[i].fireball.visible = show;
        }
      } else {
        this._fireballMovies[i].bluefireball.visible = false;
        this._fireballMovies[i].fireball.visible = false;
      }
    }

    showPinkFireballMovie(i, show) {
      if (show) {
        this._fireballMovies[i].bluefireball.visible = !show;
        this._fireballMovies[i].fireball.visible = !show;
        this._fireballMovies[i].pinkfireball.visible = show;
      } else {
        this._fireballMovies[i].bluefireball.visible = false;
        this._fireballMovies[i].fireball.visible = false;
        this._fireballMovies[i].pinkfireball.visible = false;
      }
    }

    lockFireballCashValues(lock) {
      this._lockedCashValues = lock;
    }

    updateSymbolIds(ids) {
      super.updateSymbolIds(ids);

      if (!this._ready) {
        return;
      }
      const symbols = resourceManager.getConfiguration().symbols;

      const possibleCashValues = [20, 40, 60, 80, 100, 200, 300, 400, 400];
      const firstCashFireballId = symbols["Symbol_Fireball20"].ID;
      const firstCashBlueFireballId = symbols["Symbol_BlueFireball20"].ID;

      let stake = gameController.getCurrentModeStake(true);

      for (let i = 0; i < ids.length; ++i) {
        this._fireballCashOverlays[i].visible = false;
        this.showFireballMovie(i, false);
        this._fireballPotOverlays[i].mini.visible = false;
        this._fireballPotOverlays[i].minor.visible = false;
        this._fireballPotOverlays[i].major.visible = false;
        this._fireballPotOverlays[i].mega.visible = false;
        this._blueFireballWildOverlays[i].visible = false;

        let symId = ids[i];

        switch (symId) {
          case symbols["Symbol_Fireball20"].ID:
          case symbols["Symbol_Fireball40"].ID:
          case symbols["Symbol_Fireball60"].ID:
          case symbols["Symbol_Fireball80"].ID:
          case symbols["Symbol_Fireball100"].ID:
          case symbols["Symbol_Fireball200"].ID:
          case symbols["Symbol_Fireball300"].ID:
          case symbols["Symbol_Fireball400"].ID:
          case symbols["Symbol_Fireball500"].ID: {
            const baseVal = possibleCashValues[symId - firstCashFireballId];
            const value = baseVal * (stake / gameData.numLines);
            this.showFireballMovie(i, true);
            this._fireballCashOverlays[i].visible = true;
            if (!this._lockedCashValues) {
              this._fireballCashOverlays[i].setText(gdk.formatCurrency(value));
            }
            break;
          }
          case symbols["Symbol_FireballX2"].ID: {
            this.showPinkFireballMovie(i, true);
            this._fireballCashOverlays[i].visible = true;
            this._fireballCashOverlays[i].setText("");
            break;
          }
          case symbols["Symbol_BlueFireball20"].ID:
          case symbols["Symbol_BlueFireball40"].ID:
          case symbols["Symbol_BlueFireball60"].ID:
          case symbols["Symbol_BlueFireball80"].ID:
          case symbols["Symbol_BlueFireball100"].ID:
          case symbols["Symbol_BlueFireball200"].ID:
          case symbols["Symbol_BlueFireball300"].ID:
          case symbols["Symbol_BlueFireball400"].ID:
          case symbols["Symbol_BlueFireball500"].ID: {
            if (this._showBlueFireballWild) {
              this._blueFireballWildOverlays[i].visible = true;
            } else {
              const baseVal =
                possibleCashValues[symId - firstCashBlueFireballId];
              const value = baseVal * (stake / gameData.numLines);
              this._fireballCashOverlays[i].visible = true;
              if (!this._lockedCashValues) {
                this._fireballCashOverlays[i].setText(
                  gdk.formatCurrency(value)
                );
              }
            }
            this.showFireballMovie(i, true, true);
            break;
          }
          case symbols["Symbol_FireballMini"].ID: {
            this.showFireballMovie(i, true);
            this._fireballPotOverlays[i].mini.visible = true;
            break;
          }
          case symbols["Symbol_FireballMinor"].ID: {
            this.showFireballMovie(i, true);
            this._fireballPotOverlays[i].minor.visible = true;
            break;
          }
          case symbols["Symbol_FireballMajor"].ID: {
            this.showFireballMovie(i, true);
            this._fireballPotOverlays[i].major.visible = true;
            break;
          }
          case symbols["Symbol_FireballMega"].ID: {
            this.showFireballMovie(i, true);
            this._fireballPotOverlays[i].mega.visible = true;
            break;
          }
          case symbols["Symbol_BlueFireballMini"].ID: {
            this.showFireballMovie(i, true, true);
            if (this._showBlueFireballWild) {
              this._blueFireballWildOverlays[i].visible = true;
            } else {
              this._fireballPotOverlays[i].mini.visible = true;
            }
            break;
          }
          case symbols["Symbol_BlueFireballMinor"].ID: {
            this.showFireballMovie(i, true, true);
            if (this._showBlueFireballWild) {
              this._blueFireballWildOverlays[i].visible = true;
            } else {
              this._fireballPotOverlays[i].minor.visible = true;
            }
            break;
          }
          case symbols["Symbol_BlueFireballMajor"].ID: {
            this.showFireballMovie(i, true, true);
            if (this._showBlueFireballWild) {
              this._blueFireballWildOverlays[i].visible = true;
            } else {
              this._fireballPotOverlays[i].major.visible = true;
            }
            break;
          }
          case symbols["Symbol_BlueFireballMega"].ID: {
            this.showFireballMovie(i, true, true);
            if (this._showBlueFireballWild) {
              this._blueFireballWildOverlays[i].visible = true;
            } else {
              this._fireballPotOverlays[i].mega.visible = true;
            }
            break;
          }
        }
      }
    }
  }

  function createStacked(json) {
    let sm = resourceManager.getController(json.slotMachineName);
    let reservedSpace = json.slotMachineName === "SlotMachineColossal" ? 8 : 4;
    return new ReelSpinnerVisualStacked(
      json.ID,
      json.ID + " container",
      json.appertureHeight,
      sm,
      json.minSymbolSpacing,
      reservedSpace,
      1,
      1,
      json.stackLayout,
      json.stackedSymbols
    );
  }

  function initialiseStacked(json, reelSpinnerVisual) {
    reelSpinnerVisual._slotMachineName = json.slotMachineName;

    let i = reelSpinnerVisual._reelSpinnerData._reservedSpace;
    let jsonObj = {
      format: "list",
      files: [],
    };

    let textureListsName = "symbols";
    var symbolsList = resourceManager.getConfiguration()[textureListsName];
    for (var prop in symbolsList) {
      if (typeof symbolsList[prop] === "object") {
        // Add the first texture of each symbol
        let texture = textureParser.getTextureList(
          symbolsList[prop].texture
        )[0];
        jsonObj.files.push(
          texture.textureCacheIds[0].replace(ReflexLoader.rootResDir, "")
        );
      }
    }

    textureParser.addTextureList(textureListsName, jsonObj);
    textureParser.getTextureList(textureListsName);

    reelSpinnerVisual.initialise(json, reelSpinnerVisual);
    // CRAIG TODO - sizes

    for (let i = 0; i < reelSpinnerVisual._symbolGfxObjects.length; ++i) {
      reelSpinnerVisual._symbolGfxObjects[i].symbol.mask = new PIXI.Graphics();
      reelSpinnerVisual._symbolGfxObjects[i].symbol.mask.beginFill(0x000000, 0);
      reelSpinnerVisual._symbolGfxObjects[i].symbol.mask.drawRect(
        0,
        0,
        218,
        142
      );
      reelSpinnerVisual._symbolGfxObjects[i].symbol.mask.endFill();
      reelSpinnerVisual._symbolGfxObjects[i].symbol.addChild(
        reelSpinnerVisual._symbolGfxObjects[i].symbol.mask
      );
    }

    reelSpinnerVisual.createFireballMovies();
    reelSpinnerVisual.createBlueFireballWildOverlays();
    reelSpinnerVisual.createFireballCashOverlays();
    reelSpinnerVisual.createFireballPotOverlays();
  }

  function getRequiredFilesStacked() {
    return [
      ...textureParser.getFilesRequired("Symbol_10"),
      ...textureParser.getFilesRequired("Symbol_J"),
      ...textureParser.getFilesRequired("Symbol_Q"),
      ...textureParser.getFilesRequired("Symbol_K"),
      ...textureParser.getFilesRequired("Symbol_A"),
      ...textureParser.getFilesRequired("Axes"),
      ...textureParser.getFilesRequired("Horn"),
      ...textureParser.getFilesRequired("Ship"),
      ...textureParser.getFilesRequired("Helmet"),
      ...textureParser.getFilesRequired("Symbol_Bonus"),
      ...textureParser.getFilesRequired("Symbol_Bonus_Land"),
      ...textureParser.getFilesRequired("Symbol_Wild"),
      ...textureParser.getFilesRequired("Symbol_SWild"),
      ...textureParser.getFilesRequired("Symbol_SWild_x2"),
      ...textureParser.getFilesRequired("Symbol_SWild_x3"),
      ...textureParser.getFilesRequired("Symbol_Fireball"),
      ...textureParser.getFilesRequired("Symbol_Hammer_Prize"),
      ...textureParser.getFilesRequired("Symbol_SWild_Land"),
      ...textureParser.getFilesRequired("Symbol_SWild_x2_Land"),
      ...textureParser.getFilesRequired("Symbol_SWild_x3_Land"),
      ...textureParser.getFilesRequired("Symbol_Fireball_Pink"),
      ...textureParser.getFilesRequired("anticipation"),
      ...textureParser.getFilesRequired("anticipation_red"),
      ...textureParser.getFilesRequired("volumeButtons"),
      ...textureParser.getFilesRequired("volumeButtonsPortrait"),
      ...textureParser.getFilesRequired("fireballIntroAnim"),
      ...textureParser.getFilesRequired("shockwave"),
    ];
  }

  resourceManager.registerObjectType(
    "ReelSpinnerVisualStacked",
    createStacked,
    initialiseStacked,
    getRequiredFilesStacked
  );
})();
